export function isMobileViewPort() {
    return window.innerWidth < 991;
}

export function isDesktopViewPort() {
    return window.innerWidth > 991;
}


// WEBPACK FOOTER //
// ./assets/js/libraries/viewport.js